import { render, staticRenderFns } from "./IR-Email Alerts_Info Create.vue?vue&type=template&id=4192b648&"
import script from "./IR-Email Alerts_Info Create.vue?vue&type=script&lang=js&"
export * from "./IR-Email Alerts_Info Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VSpacer})
